import { useTheme } from "@mui/material";

import { DonutChart } from "components/modules/charts/DonutChart";
import { useDDFilter } from "components/modules/disinfectionFilter/DisinfectionFilterPanel";
import { graphql } from "gql";
import { DisinfectionFilter } from "gql/graphql";
import { FormattedMessage } from "react-intl";
import { useQueryWithSnack } from "utils/useQueryWithSnack";

//LSBRI - TODO: FM2 does not yet support skipped positions, fix this
const QUERY = graphql(`
  query PositionsReached($filter: DisinfectionFilter!) {
    disinfectionPositionsStatuses(filter: $filter) {
      disinfected
      failed
      remaining
    }
    numberOfDisinfections(filter: $filter)
  }
`);

interface Props {
  hiddenFilter?: DisinfectionFilter;
}

export const PositionsReachedChart = ({ hiddenFilter }: Props) => {
  const theme = useTheme();

  const [filterParams] = useDDFilter();

  const { data } = useQueryWithSnack(QUERY, {
    variables: {
      filter: {
        ...filterParams,
        ...hiddenFilter,
      },
    },
    skip: !filterParams?.timeSpan,
  });

  return (
    <DonutChart
      header={
        <FormattedMessage
          id="positions-reached"
          defaultMessage="Positions Disinfected"
        />
      }
      description={
        <FormattedMessage
          id="positions-reached-description"
          defaultMessage='"Hit Rate" - Positions successfully disinfected during predefined disinfections'
        />
      }
      count={data?.disinfectionPositionsStatuses.disinfected ?? 0}
      totalCount={
        (data?.disinfectionPositionsStatuses?.disinfected ?? 0) +
        (data?.disinfectionPositionsStatuses?.failed ?? 0) +
        (data?.disinfectionPositionsStatuses?.remaining ?? 0)
      }
      paperProps={{
        style: {
          backgroundColor: theme.palette.success.main,
        },
      }}
      paperTextColor="white"
      donutSize={112}
      donutColor="white"
      donutBackgroundColor="rgba(24, 28, 50, 0.05)"
      donutTextColor="white"
      dataUnknown={data === undefined}
    />
  );
};
